import api from './api';
import { normalizeListResponse } from '../utils/listResponse';

export type ActivityType = 'create' | 'update' | 'delete';

export interface ActivityLog {
  id: string;
  activity_type: ActivityType;
  module: string;
  reference_id: string;
  reference_label?: string;
  user_id: string;
  user_name?: string;
  company_id: string;
  properties: Record<string, unknown> | null;
  changes: { before: Record<string, unknown>; after: Record<string, unknown> } | null;
  created_at: string;
}

export interface ListActivityLogsParams {
  module?: string;
  user_id?: string;
  reference_id?: string;
  start_date?: string;
  end_date?: string;
  page?: number;
  size?: number;
}

export const activityLogService = {
  list: async (
    params: ListActivityLogsParams = {},
  ): Promise<{ data: ActivityLog[]; total: number }> => {
    const { page = 1, size = 25, module, user_id, reference_id, start_date, end_date } = params;
    const query = new URLSearchParams();
    query.set('limit', String(size));
    query.set('offset', String((page - 1) * size));
    if (module) query.set('module', module);
    if (user_id) query.set('user_id', user_id);
    if (reference_id) query.set('reference_id', reference_id);
    if (start_date) query.set('start_date', start_date);
    if (end_date) query.set('end_date', end_date);
    const response = await api.get(`/activity-logs?${query.toString()}`);
    return normalizeListResponse<ActivityLog>(response.data);
  },
};
